<template>
	<div class="global-progress-attachment-file-item">
		<div class="file-item--content">

			<div class="item-image">
				<v-img
					contain
					:src="getPreview">
				</v-img>
			</div>

			<div class="item-name">	
				<p>{{ getFileName }}</p>
			</div>

			<div class="item-size">
				<p>{{ getFileSize | f__bytesToString }}</p>
			</div>

			<div
				v-if="data.status == $store.state.constants.SILA_FILE_UPLOAD_STATUS_STARTED" 
				class="item-progress">
				<div class="progress-ind-container">
					<div class="progress-ind" :style="fileProgress"/>
				</div>
				<div class="progress-string">
					<p>{{ fileProgressPercent }}</p>
				</div>
			</div>

			<div
				v-if="getStatus" 
				class="item-status">
				<div class="item-status--inner">
					<div class="status-icon">
						<v-icon 
							v-if="getStatus.icon"
							size="21"
							:color="getStatus.icon.color">
							{{getStatus.icon.symbol}}
						</v-icon>
					</div>

					<div class="status-text">
						<p>{{getStatus.text}}</p>
					</div>			
				</div>
			</div>

			<!-- <div class="item-actions">
				<v-tooltip
					top
					open-delay="400">
					<v-icon
						slot="activator"
						size="16px"
						class="item-action"
						color="grey darken-1"
						@click.stop="abortUpload">
						cancel</v-icon>
					<span class="grey--text text--lighten-3">Stop Upload</span>
				</v-tooltip>
			</div> -->
		</div>

		<div class="file-item--divider"/>
	</div>
</template>


<script>
	import { mapState, mapActions, mapGetters } from 'vuex'

	// import { VUEX_UPLOAD_ABORT } from '@/store/constants/upload'

	import bytesToString from '@/mixins/filters/bytesToString'

	export default {
		name: 'global-attachment-file-item',

		props: {
			data: {
				type: Object,
				required: true,
				default: null
			},
		},

		data:() => ({}),

		computed: {
			getPreview() { return this.data.preview ? this.data.preview : require('@/assets/images/no-preview-available-dark.jpg') },

			getFileName() {
				return (this.data.file) ? this.data.file.name : this.data.filename
			},

			getFileSize() {
				return (this.data.file) ? this.data.file.size : ''
			},

			fileProgressBytes() { 
				let total = bytesToString(this.data.progress.total, 1)
				let loaded = bytesToString(this.data.progress.loaded, 1)
				return loaded + " / " + total
			},

			fileProgress() { 
				let total = this.data.progress.total
				let loaded = this.data.progress.loaded
				
				if(!total) return 0
				return { transform:'scaleX(' + loaded/total + ')' }
			},

			fileProgressPercent() { 
				let total = this.data.progress.total
				let loaded = this.data.progress.loaded
				return (total) ? (loaded/total * 100).toFixed(1) + "%" : "0.0%"
			},

			getStatus() {
				switch(this.data.status) {
					case SILA_FILE_UPLOAD_STATUS_PENDING :
						return {
							icon: null,
							text: 'QUEUED'
						}

					case SILA_FILE_UPLOAD_STATUS_STARTED :
						return null

					case SILA_FILE_UPLOAD_STATUS_SUCCESS :
						return {
							text: 'COMPLETED',
							icon: {
								color: 'green',
								symbol: 'check'
							},
						}

					case SILA_FILE_UPLOAD_STATUS_SUCCESS :
						return {
							text: 'FAILED',
							icon: {
								color: 'red',
								symbol: 'warning'
							},
						}
							
					default :
						return null
				}
			}
		},

		methods: {
			...mapActions({
				// abortUpload: VUEX_UPLOAD_ABORT
			})
		}
	}
</script>